// Review
export const REVIEW_STATE_RESET = 'REVIEW_STATE_RESET';
export const REVIEW_ITEMS_PENDING = 'REVIEW_ITEMS_PENDING';
export const REVIEW_ITEMS_SUCCESS = 'REVIEW_ITEMS_SUCCESS';
export const REVIEW_ITEMS_FAILURE = 'REVIEW_ITEMS_FAILURE';

// Update approval status
export const REVIEW_APPROVAL_STATUS_APPROVE_PENDING = 'REVIEW_APPROVAL_STATUS_APPROVE_PENDING';
export const REVIEW_APPROVAL_STATUS_APPROVE_SUCCESS = 'REVIEW_APPROVAL_STATUS_APPROVE_SUCCESS';
export const REVIEW_APPROVAL_STATUS_APPROVE_FAILURE = 'REVIEW_APPROVAL_STATUS_APPROVE_FAILURE';

export const REVIEW_APPROVAL_STATUS_DISAPPROVE_PENDING = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_PENDING';
export const REVIEW_APPROVAL_STATUS_DISAPPROVE_SUCCESS = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_SUCCESS';
export const REVIEW_APPROVAL_STATUS_DISAPPROVE_FAILURE = 'REVIEW_APPROVAL_STATUS_DISAPPROVE_FAILURE';

// Update review information text
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_PENDING = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_PENDING';
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_SUCCESS = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_SUCCESS';
export const REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_FAILURE = 'REVIEW_UPDATE_REVIEW_INFORMATION_TEXT_FAILURE';

// Review filter
export const REVIEW_FILTER_ITEMS_PENDING = 'REVIEW_FILTER_ITEMS_PENDING';
export const REVIEW_FILTER_ITEMS_SUCCESS = 'REVIEW_FILTER_ITEMS_SUCCESS';
export const REVIEW_FILTER_ITEMS_FAILURE = 'REVIEW_FILTER_ITEMS_FAILURE';

export const REVIEW_FILTER_UPDATE_SELECTED_BRANDS = 'REVIEW_FILTER_UPDATE_SELECTED_BRANDS';
export const REVIEW_FILTER_UPDATE_SELECTED_DOMAINS = 'REVIEW_FILTER_UPDATE_SELECTED_DOMAINS';

export const REVIEW_FILTER_RESET_REVIEWS = 'REVIEW_FILTER_RESET_REVIEWS';

export const REVIEW_FILTER_UPDATE_SORT = 'REVIEW_FILTER_UPDATE_SORT';

export const REVIEW_FILTER_SITE_ITEMS_PENDING = 'REVIEW_FILTER_SITE_ITEMS_PENDING';
export const REVIEW_FILTER_SITE_ITEMS_SUCCESS = 'REVIEW_FILTER_SITE_ITEMS_SUCCESS';
export const REVIEW_FILTER_SITE_ITEMS_FAILURE = 'REVIEW_FILTER_SITE_ITEMS_FAILURE';
export const REVIEW_FILTER_UPDATE_SELECTED_SITES = 'REVIEW_FILTER_UPDATE_SELECTED_SITES';

// Bulk buttons
export const REVIEW_BULK_SELECT_ALL = 'REVIEW_BULK_SELECT_ALL';
export const REVIEW_BULK_DESELECT_ALL = 'REVIEW_BULK_DESELECT_ALL';
export const REVIEW_BULK_UPDATE_SELECT = 'REVIEW_BULK_UPDATE_SELECT';

// Review overview
export const REVIEW_OVERVIEW_PENDING = 'REVIEW_OVERVIEW_PENDING';
export const REVIEW_OVERVIEW_SUCCESS = 'REVIEW_OVERVIEW_SUCCESS';
export const REVIEW_OVERVIEW_FAILURE = 'REVIEW_OVERVIEW_FAILURE';

export const REVIEW_OVERVIEW_APPROVAL_STATUS_FILTER = 'REVIEW_OVERVIEW_APPROVAL_STATUS_FILTER';

// Review Settings
export const REVIEW_SETTINGS_STATE_RESET = 'REVIEW_SETTINGS_STATE_RESET';

export const REVIEW_SETTINGS_ITEMS_PENDING = 'REVIEW_SETTINGS_ITEMS_PENDING';
export const REVIEW_SETTINGS_ITEMS_SUCCESS = 'REVIEW_SETTINGS_ITEMS_SUCCESS';
export const REVIEW_SETTINGS_ITEMS_FAILURE = 'REVIEW_SETTINGS_ITEMS_FAILURE';

export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING';
export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS';
export const REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE = 'REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE';

export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING';
export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS';
export const REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE = 'REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE';

// App
export const APP_SESSION_INFO_SET = 'APP_SESSION_INFO_SET';



// WEBPACK FOOTER //
// ./src/store/modules/constants.js